<template>
  <div class="container min-vh-100">
    <div class="row min-vh-100">
      <div class="col-4 m-auto text-center">
        <CIcon name="cil-thumb-down" size="8xl" />
        <h1>Página no encontrada</h1>
        <p>No se encontró la página que esta buscando</p>
        <router-link to="/dashboard" custom v-slot="{ href, navigate }">
          <a :href="href" class="btn btn-primary" @click="navigate">
            Volver al inicio
          </a>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Page_404",
};
</script>
